module.exports = __webpack_public_path__ + "static/consulting-67b646564abd4fdd0d3930b5aad7a27a.svg";